import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';

import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Router } from '@angular/router';
import { GlobalService } from './global.service';
@Injectable()
export class KycService {

  constructor(private http: Http, private router: Router) { }

  public addKyc(formdata) {
    const role = localStorage.getItem('role');
    console.log('role', role);

    if (role === 'seller') {
      const data = {
        'GSTNumber': (formdata.gst),
        'IFSCCode': formdata.IFSC,
        'PANNumber': (formdata.pan),
        'TANNumber': formdata.tan,
        'accountName': formdata.accntName,
        'accountNumber': formdata.accntNum,
        'bankName': formdata.bankName,
        'branchAddress': formdata.branchAddress,
        'city': formdata.city,
        'companyFullAddress': formdata.address,
        'productCategory': formdata.productCategory,
        'companyFullName': formdata.companyfullName,
        'companyType': formdata.companyType,
        'country': formdata.country,
        'emailId': formdata.email,
        'phoneNumber': formdata.phone,
        'mobileNumber': formdata.mobileNumber,
        'pinCode': formdata.pincode,
        'roles': [ role ],
        'state': formdata.state,
        'websiteAddress': formdata.website
      };
      console.log('data', data);
      const body = JSON.stringify(data);
      console.log(body);
      return this.http.post(environment.baseUrl + '/user/kyc', body, GlobalService.getHeaders()).map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        if (response.status === 200 ) {
          return user;
        }
       }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
  
          const err = error.json();
          err.responseStatus = error.status;
          
          return Observable.throw(err);
        } else if (error.status === 400) {
  
          const err = error.json();
          err.responseStatus = error.status;
          
          return Observable.throw(err);
        } else if (error.status === 401) {
  
          const err = error.json();
          err.responseStatus = error.status;
          
          return Observable.throw(err);
        }
      });
    }

    if (role === 'buyer') {
    const data = {
        'GSTNumber': (formdata.gst).toUpperCase(),
        'IFSCCode': (formdata.IFSC).toUpperCase(),
        'PANNumber': (formdata.pan).toUpperCase(),
        'TANNumber': formdata.tan,
        'accountName': formdata.accntName,
        'accountNumber': formdata.accntNum,
        'bankName': formdata.bankName,
        'branchAddress': formdata.branchAddress,
        'city': formdata.city,
        'companyFullAddress': formdata.address,
        'companyFullName': formdata.companyfullName,
        'companytype': formdata.companyType,
        'country': formdata.country,
        'emailId': formdata.email,
        'phoneNumber': formdata.phone,
        'mobileNumber': formdata.mobileNumber,
        'pinCode': formdata.pincode,
        'roles': [ role ],
        'state': formdata.state,
        'websiteAddress': formdata.website
      };
      console.log('data', data);
    const body = JSON.stringify(data);
    console.log(body);
    return this.http.post(environment.baseUrl + '/user/kyc', body, GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      if (response.status === 200 ) {
        return user;
      }
     }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      } else if (error.status === 400) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      } else if (error.status === 401) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      }
    });
    }
    // console.log('data', data);
    // const body = JSON.stringify(data);
    // console.log(body);
    // const head = new Headers({
    //     'Content-Type': 'application/json'
    // });
  }

  public addBankerKyc(formdata, bankInfo) {
    const role = localStorage.getItem('role');
    console.log('role', role);
    console.log(bankInfo);
    const data = {
        'category': role,
        'name': bankInfo.name,
        'branch': bankInfo.branch,
        'city': bankInfo.city,
        'state': bankInfo.state,
        'license': formdata.license,
        'address': bankInfo.address,
        'poc': formdata.poc,
        'phoneNumber': formdata.phoneNumber,
        'mobileNumber' : formdata.mobileNumber,
        // 'email': formdata.email,
        'IFSC': (formdata.IFSC).toUpperCase(),
      };
    console.log('data', data);
    const body = JSON.stringify(data);
    console.log(body);
    const head = new Headers({
        'Content-Type': 'application/json'
    });
    return this.http.post(environment.baseUrl + '/banker/kyc', body, GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      if (response.status === 200 ) {
        return user;
      }
     }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      } else if (error.status === 400) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      } else if (error.status === 401) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      }
    });
  }

  public addNBFCKyc(formdata, nbfcInfo) {
    const role = localStorage.getItem('role');
    console.log('role', role);
    const data = {
        'category': role,
        'type': formdata.type,
        'license': formdata.license,
        'poc': formdata.poc,
        'phoneNumber': formdata.phoneNumber,
        'mobileNumber' : formdata.mobileNumber,
        'name': nbfcInfo.name,
        'branch': nbfcInfo.branch,
        'city': nbfcInfo.city,
        'state': nbfcInfo.state,
        'address': nbfcInfo.address,
        // 'email': formdata.email
      };
    console.log('data', data);
    const body = JSON.stringify(data);
    console.log(body);
    const head = new Headers({
        'Content-Type': 'application/json'
    });
    return this.http.post(environment.baseUrl + '/banker/kyc', body, GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      if (response.status === 200 ) {
        return user;
      }
     }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      } else if (error.status === 400) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      } else if (error.status === 401) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      }
    });
  }

  public getKYC() {
    return this.http.get(environment.baseUrl + '/user/kyc', GlobalService.getHeaders()).map((response: Response) => {

      const user = response.json();
      user.responseStatus = response.status;

      return user;
    }).catch((error) => {

      if (error.status === 500) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      } else if (error.status === 400) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      } else if (error.status === 401) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      }
  });
  }

  // 
  // cp customer
  public cpKYC(userEmail: any) {
    console.log('inside services');
    const email = userEmail;
    return this.http.get(environment.baseUrl + '/admin/kyc_cp_users/' + userEmail, GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      } else if (error.status === 400) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      } else if (error.status === 401) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      }
  });
  }
  // 

  public changeStatus() {
    console.log('on get kyc');
    return this.http.get(environment.baseUrl + '/user/status', GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      } else if (error.status === 400) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      } else if (error.status === 401) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      }
  });
  }
  public  OnPANUpload(Image) {
    console.log('image', Image);
    const email = localStorage.getItem('emailId');
    console.log('email+++++++++++', email);
    const role = localStorage.getItem('role');
    const formData: FormData = new FormData();
    formData.append('PAN', Image);
    formData.append('emailId', email);
    formData.append('roles', role);
    return this.http.post(environment.docUrl + '/kyc/docs', formData).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    });
  }

  public OnTANUpload(Image) {
    console.log('image', Image);
    const email = localStorage.getItem('emailId');
    console.log('email+++++++++++', email);
    const role = localStorage.getItem('role');
    const formData: FormData = new FormData();
    formData.append('TAN', Image);
    formData.append('emailId', email);
    formData.append('roles', role);
    console.log('formDtat', formData);
    return this.http.post(environment.docUrl + '/kyc/docs', formData).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    });
  }
  public OnGSTUpload(Image) {
    console.log('image', Image);
    const email = localStorage.getItem('emailId');
    console.log('email+++++++++++', email);
    const role = localStorage.getItem('role');
    const formData: FormData = new FormData();
    formData.append('GST', Image);
    formData.append('emailId', email);
    formData.append('roles', role);
    return this.http.post(environment.docUrl + '/kyc/docs', formData).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    });
  }
  public OnMOAUpload(Image) {
    console.log('image', Image);
    const email = localStorage.getItem('emailId');
    console.log('email+++++++++++', email);
    const role = localStorage.getItem('role');
    const formData: FormData = new FormData();
    formData.append('MOA', Image);
    formData.append('emailId', email);
    formData.append('roles', role);
    return this.http.post(environment.docUrl + '/kyc/docs', formData).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    });
  }
  public OnAOAUpload(Image) {
    console.log('image', Image);
    const email = localStorage.getItem('emailId');
    console.log('email+++++++++++', email);
    const role = localStorage.getItem('role');
    const formData: FormData = new FormData();
    formData.append('AOA', Image);
    formData.append('emailId', email);
    formData.append('roles', role);
    return this.http.post(environment.docUrl + '/kyc/docs', formData).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    });
  }
  public OnCOIUpload(Image) {
    console.log('image', Image);
    const email = localStorage.getItem('emailId');
    console.log('email+++++++++++', email);
    const role = localStorage.getItem('role');
    const formData: FormData = new FormData();
    formData.append('COI', Image);
    formData.append('emailId', email);
    formData.append('roles', role);
    return this.http.post(environment.docUrl + '/kyc/docs', formData).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    });
  }

  public OnProfileImageUpload(Image) {
    console.log('image', Image);
    const email = localStorage.getItem('userEmail');
    const role = localStorage.getItem('role');
    console.log('email+++++++++++', email);
    const formData: FormData = new FormData();
    formData.append('profilePicture', Image);
    formData.append('emailId', email);
    formData.append('roles', role);
    console.log('formData', formData);
    return this.http.post(environment.docUrl + '/kyc/docs', formData).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    });
  }

  public OnLogoImageUpload(Image) {
    console.log('image', Image);
    const email = localStorage.getItem('userEmail');
    const role = localStorage.getItem('role');
    console.log('email+++++++++++', email);
    const formData: FormData = new FormData();
    formData.append('profilePicture', Image);
    formData.append('emailId', email);
    formData.append('roles', role);
    return this.http.post(environment.docUrl + '/kyc/docs', formData).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    });
  }

  public getProfilePicHash(userEmail: any) {
    console.log('inside services pic hash++++', userEmail);
    const emailId = userEmail;
    return this.http.get(environment.docUrl + '/kyc/docs/' + emailId + '/profilePicture',
    GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      } else if (error.status === 400) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      } else if (error.status === 401) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      }
  });
  }

  public getBuyerProfilePicHash(buyerEmail: any) {
    console.log('inside services pic hash++++', buyerEmail);
    const emailId = buyerEmail;
    return this.http.get(environment.docUrl +  '/kyc/docs/' + emailId + '/profilePicture',
    GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      } else if (error.status === 400) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      } else if (error.status === 401) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      }
  });
  }

  public getSellerProfilePicHash(sellerEmail: any) {
    console.log('inside services pic hash++++', sellerEmail);
    const emailId = sellerEmail;
    return this.http.get(environment.docUrl +  '/kyc/docs/' + emailId + '/profilePicture',
    GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      } else if (error.status === 400) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      } else if (error.status === 401) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      }
  });
  }

  public OnIfscDetails(ifsc) {
    console.log('ifsc code', ifsc);
    const ifscCode = ifsc;
  return this.http.get(environment.baseUrl + '/banker/kyc/ifsc/' + ifscCode , GlobalService.getHeaders()).map((response: Response) => {
    console.log(response.status);
    const user = response.json();
    user.responseStatus = response.status;
    console.log(user);
    if (response.status === 200 ) {
      return user;
    }
   }).catch((error) => {
    console.log('error', error);
    if (error.status === 500) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 400) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 401) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    }
  });
  }

  public OnListIndustries() {
    console.log('inside get all industries');
    return this.http.get(environment.baseUrl + '/user/resources').map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      console.log(user);
      return user;
    }); 
  }

public PanVerify(pan) {
  const sellerId = localStorage.getItem('userEmail');
 
  const data = {
    "userid" : sellerId,
    "panNumber" : pan.toUpperCase()
    };
  console.log('data', data);
  const body = JSON.stringify(data);
  console.log(body);
  return this.http.post(environment.baseUrl + '/cam/pan_verification', body,GlobalService.getHeaders()).map((response: Response) => {
    console.log(response.status);
    const user = response.json();
    user.responseStatus = response.status;
    console.log(user);
    if (response.status === 200 ) {
      return user;
    }
   }).catch((error) => {
    console.log('error', error);
    if (error.status === 500) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 400) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 401) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    }
  });
} 
// channel pan verification
public ChannelPanVerify(pan,emailId) {
  const data = {
    "userid" : emailId,
    "panNumber" : pan.toUpperCase()
    };
  console.log('data', data);
  const body = JSON.stringify(data);
  console.log(body);
  return this.http.post(environment.baseUrl + '/cam/pan_verification', body,GlobalService.getHeaders()).map((response: Response) => {
    console.log(response.status);
    const user = response.json();
    user.responseStatus = response.status;
    console.log(user);
    if (response.status === 200 ) {
      return user;
    }
   }).catch((error) => {
    console.log('error', error);
    if (error.status === 500) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 400) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 401) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    }
  });
} 
// aadhar
public AadharUpload(Image) {
  console.log('image', Image);
  const sellerId = localStorage.getItem('userEmail');

  const formData: FormData = new FormData();
  formData.append('file', Image);
  formData.append('userid', sellerId);
//   const head = new Headers({
   
//     'userid': sellerId
// });
 const token = localStorage.getItem('currentUser');
 console.log('token', token);
 const headerToken = 'Bearer ' + token;
 const headers = new Headers();
 headers.append('Authorization', headerToken);

  return this.http.post(environment.baseUrl + '/cam/kyc_orc_aadhar', formData,{headers: headers}).map((response: Response) => {
    const user = response.json();
    console.log(response.status);
    user.responseStatus = response.status;
    if (response.status === 200 ) {
      return user;
    }
   }).catch((error) => {
    console.log('error', error);
    if (error.status === 500) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 400) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 401) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    }
  });
}

// 
// aadhar
public BankStatementUpload(Image) {
  console.log('image', Image);
  const sellerId = localStorage.getItem('userEmail');
  const roles = localStorage.getItem('role');
  const formData: FormData = new FormData();
  formData.append('bankstatement', Image);
  formData.append('emailId', sellerId);
  formData.append('roles', roles);
 return this.http.post(environment.docUrl + '/kyc/docs', formData).map((response: Response) => {
    console.log(response.status);
    const user = response.json();
    user.responseStatus = response.status;
    if (response.status === 200 ) {
      return user;
    }
   }).catch((error) => {
    console.log('error', error);
    if (error.status === 500) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 400) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 401) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    }
  });
}

// channel bank statement upload
public BankStatementUploadChannel(Image,emailId) {
  console.log('image', Image);
  const roles = localStorage.getItem('userRole');
  const formData: FormData = new FormData();
  formData.append('bankstatement', Image);
  formData.append('emailId', emailId);
  formData.append('roles', roles);
 return this.http.post(environment.docUrl + '/kyc/docs_for_cp', formData).map((response: Response) => {
    console.log(response.status);
    const user = response.json();
    user.responseStatus = response.status;
    if (response.status === 200 ) {
      return user;
    }
   }).catch((error) => {
    console.log('error', error);
    if (error.status === 500) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 400) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 401) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    }
  });
}

// docs
 
public otherDocsUpload(Image,name) {
  console.log('image', Image);
  const sellerId = localStorage.getItem('userEmail');
  const roles = localStorage.getItem('role');
  const formData: FormData = new FormData();
  formData.append('otherDocs', Image);
  formData.append('emailId', sellerId);
  formData.append('roles', roles);
  formData.append('name', name);

  return this.http.post(environment.docUrl + '/kyc/docs', formData).map((response: Response) => {
    console.log(response.status);
    const user = response.json();
    user.responseStatus = response.status;
    if (response.status === 200 ) {
      return user;
    }
   }).catch((error) => {
    console.log('error', error);
    if (error.status === 500) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 400) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 401) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    }
  });
}
// for channel docs
public otherDocsChannel(Image,DocName) {
  console.log('image', Image);
  const emailId = localStorage.getItem('userEmail');
  const roles = localStorage.getItem('userRole');
  const formData: FormData = new FormData();
  formData.append('otherDocs', Image);
  formData.append('emailId', emailId);
  formData.append('roles', roles);
  formData.append('name', DocName);


  return this.http.post(environment.docUrl + '/kyc/docs', formData).map((response: Response) => {
    console.log(response.status);
    const user = response.json();
    user.responseStatus = response.status;
    if (response.status === 200 ) {
      return user;
    }
   }).catch((error) => {
    console.log('error', error);
    if (error.status === 500) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 400) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 401) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    }
  });
}
// channel upload others documentsssssssssppp
public otherDocsUploadChannel(Image,emailId,name) {
  console.log('image', Image);
 
  const roles = localStorage.getItem('userRole');
  const formData: FormData = new FormData();
  formData.append('otherDocs', Image);
  formData.append('emailId', emailId);
  formData.append('roles', roles);
  formData.append('name', name);


  return this.http.post(environment.docUrl + '/kyc/docs_for_cp', formData).map((response: Response) => {
    console.log(response.status);
    const user = response.json();
    user.responseStatus = response.status;
    if (response.status === 200 ) {
      return user;
    }
   }).catch((error) => {
    console.log('error', error);
    if (error.status === 500) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 400) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 401) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    }
  });
}
// others upload docs
public DocsUpload(Image,role,emailId,name) {
  console.log('image', Image);
  const sellerId = emailId;
  const roles = role;
  const formData: FormData = new FormData();
  formData.append('otherDocs', Image);
  formData.append('emailId', sellerId);
  formData.append('roles', roles);
  formData.append('name', name);


  return this.http.post(environment.docUrl + '/kyc/docs', formData).map((response: Response) => {
    console.log(response.status);
    const user = response.json();
    user.responseStatus = response.status;
    if (response.status === 200 ) {
      return user;
    }
   }).catch((error) => {
    console.log('error', error);
    if (error.status === 500) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 400) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 401) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    }
  });
}
// profile picture
// aadhar
public profilePictureUpload(Image) {
  console.log('image', Image);
  const sellerId = localStorage.getItem('userEmail');
  const roles = localStorage.getItem('role');
  const formData: FormData = new FormData();
  formData.append('profilePicture', Image);
  formData.append('emailId', sellerId);
  formData.append('roles', roles);

  return this.http.post(environment.docUrl + '/kyc/docs', formData).map((response: Response) => {
    console.log(response.status);
    const user = response.json(); 
    user.responseStatus = response.status;
    if (response.status === 200 ) {
      return user;
    }
   }).catch((error) => {
    console.log('error', error);
    if (error.status === 500) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 400) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 401) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    }
  });
}
// progile upload channel user

public userImageUpload(Image,emailId) {
  console.log('image', Image);
  // const sellerId = localStorage.getItem('userEmail');
  const roles = localStorage.getItem('userRole');
  const formData: FormData = new FormData();
  formData.append('userProfilePic', Image);
  formData.append('emailId', emailId);
  formData.append('roles', roles);

  return this.http.post(environment.docUrl + '/kyc/docs_for_cp', formData).map((response: Response) => {
    console.log(response.status);
    const user = response.json(); 
    user.responseStatus = response.status;
    if (response.status === 200 ) {
      return user;
    }
   }).catch((error) => {
    console.log('error', error);
    if (error.status === 500) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 400) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 401) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    }
  });
}
// upload logo by channel
public profilePictureUploadChannel(Image,emailId) {
  console.log('image', Image);

  const roles = localStorage.getItem('userRole');
  const formData: FormData = new FormData();
  formData.append('profilePicture', Image);
  formData.append('emailId', emailId);
  formData.append('roles', roles);

  return this.http.post(environment.docUrl + '/kyc/docs_for_cp', formData).map((response: Response) => {
    console.log(response.status);
    const user = response.json(); 
    user.responseStatus = response.status;
    if (response.status === 200 ) {
      return user;
    }
   }).catch((error) => {
    console.log('error', error);
    if (error.status === 500) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 400) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 401) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    }
  });
}
// self adhaar
// aadhar
public selfAdhaarUpload(Image) {
  console.log('image', Image);
  const sellerId = localStorage.getItem('userEmail');
  const roles = localStorage.getItem('role');
  const formData: FormData = new FormData();
  formData.append('adharImage', Image);
  formData.append('emailId', sellerId);
  formData.append('roles', roles);
  return this.http.post(environment.docUrl + '/kyc/docs', formData).map((response: Response) => {
    console.log(response.status);
    const user = response.json();
    user.responseStatus = response.status;
    if (response.status === 200 ) {
      return user;
    }
   }).catch((error) => {
    console.log('error', error);
    if (error.status === 500) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 400) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 401) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    }
  });
}
// 
// co applicant aadhar
public CoapplicantUpload(Image) {
  console.log('image', Image);
  const sellerId = localStorage.getItem('userEmail');
  const roles = localStorage.getItem('role');
  const formData: FormData = new FormData();
  formData.append('coAadharImage', Image);
  formData.append('emailId', sellerId);
  formData.append('roles', roles);
  return this.http.post(environment.docUrl + '/kyc/docs', formData).map((response: Response) => {
    console.log(response.status);
    const user = response.json();
    user.responseStatus = response.status;
    if (response.status === 200 ) {
      return user;
    }
   }).catch((error) => {
    console.log('error', error);
    if (error.status === 500) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 400) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 401) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    }
  });
}
// channel aadhar upload
public selfAdhaarUploadChannel(Image,emailId) {
  console.log('image', Image);
  // const sellerId = localStorage.getItem('userEmail');
  const roles = localStorage.getItem('userRole');
  // const roles = 'buyer'
  const formData: FormData = new FormData();
  formData.append('adharImage', Image);
  formData.append('emailId', emailId);
  formData.append('roles', roles);
  return this.http.post(environment.docUrl + '/kyc/docs_for_cp', formData).map((response: Response) => {
    console.log(response.status);
    const user = response.json();
    user.responseStatus = response.status;
    if (response.status === 200 ) {
      return user;
    }
   }).catch((error) => {
    console.log('error', error);
    if (error.status === 500) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 400) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 401) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    }
  });
}
// 
public coApplicatUploadChannel(Image,emailId) {
  console.log('image', Image);
  // const sellerId = localStorage.getItem('userEmail');
  const roles = localStorage.getItem('userRole');
  // const roles = 'buyer'
  const formData: FormData = new FormData();
  formData.append('coAadharImage', Image);
  formData.append('emailId', emailId);
  formData.append('roles', roles);
  return this.http.post(environment.docUrl + '/kyc/docs_for_cp', formData).map((response: Response) => {
    console.log(response.status);
    const user = response.json();
    user.responseStatus = response.status;
    if (response.status === 200 ) {
      return user;
    }
   }).catch((error) => {
    console.log('error', error);
    if (error.status === 500) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 400) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 401) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    }
  });
}
//  
public BackAdhaarUploadChannel(Image,emailId) {
  console.log('image', Image);
  // const sellerId = localStorage.getItem('userEmail');
  const roles = localStorage.getItem('userRole');
  // const roles = 'buyer'
  const formData: FormData = new FormData();
  formData.append('aadharImageBack', Image);
  formData.append('emailId', emailId);
  formData.append('roles', roles);
  return this.http.post(environment.docUrl + '/kyc/docs_for_cp', formData).map((response: Response) => {
    console.log(response.status);
    const user = response.json();
    user.responseStatus = response.status;
    if (response.status === 200 ) {
      return user;
    }
   }).catch((error) => {
    console.log('error', error);
    if (error.status === 500) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 400) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 401) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    }
  });
}
// gst
public GstVerify(formdata) {
  const sellerId = localStorage.getItem('userEmail');
 
  const data = {
    "userid" : sellerId,
    "gstin" : (formdata.gst).toUpperCase(),
    "email" : formdata.email,
    "mobile" : formdata.mobileNumber,
    "customerName" : formdata.companyfullName
    // "username" :formdata.gstusername,
    // "password" : formdata.gstpass
    };
  console.log('data', data);
  const body = JSON.stringify(data);
  console.log(body);
  const head = new Headers({
      'Content-Type': 'application/json'
  });
  return this.http.post(environment.panUrl + '/verification/gstcredlink', body,{headers: head}).map((response: Response) => {
    console.log(response.status);
    const user = response.json();
    user.responseStatus = response.status;
    console.log(user);
    if (response.status === 200 ) {
      return user;
    }
   }).catch((error) => {
    console.log('error', error);
    if (error.status === 500) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 400) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 401) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    }
  });
}
// itr verification
// gst
// public ITRVerify(formdata) {
//   const sellerId = localStorage.getItem('userEmail');
 
//   const data = {
//     "userid" : sellerId,
//     "username" :formdata.itrUsername,
//     "password" : formdata.itrPass
//     };
//   console.log('data', data);
//   const body = JSON.stringify(data);
//   console.log(body);
//   const head = new Headers({
//       'Content-Type': 'application/json'
//   });
//   return this.http.post(environment.panUrl + '/verification/validateitr', body,{headers: head}).map((response: Response) => {
//     console.log(response.status);
//     const user = response.json();
//     user.responseStatus = response.status;
//     console.log(user);
//     if (response.status === 200 ) {
//       return user;
//     }
//    }).catch((error) => {
//     console.log('error', error);
//     if (error.status === 500) {
//
//       const err = error.json();
//       err.responseStatus = error.status;
//       
//       return Observable.throw(err);
//     } else if (error.status === 400) {
//
//       const err = error.json();
//       err.responseStatus = error.status;
//       
//       return Observable.throw(err);
//     } else if (error.status === 401) {
//
//       const err = error.json();
//       err.responseStatus = error.status;
//       
//       return Observable.throw(err);
//     }
//   });
// }
public ITRVerify(formdata) {
  const sellerId = localStorage.getItem('userEmail');
 
  const data = {
    "userid" : sellerId,
    "pan" : (formdata.ComPan).toUpperCase(),
    "email" : formdata.email,
    "mobile" : formdata.mobileNumber,
    "customerName" : formdata.companyfullName
    };
  console.log('data', data);
  const body = JSON.stringify(data);
  console.log(body);
  const head = new Headers({
      'Content-Type': 'application/json'
  });
  return this.http.post(environment.panUrl + '/verification/itrcredlink', body,{headers: head}).map((response: Response) => {
    console.log(response.status);
    const user = response.json();
    user.responseStatus = response.status;
    console.log(user);
    if (response.status === 200 ) {
      return user;
    }
   }).catch((error) => {
    console.log('error', error);
    if (error.status === 500) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 400) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 401) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    }
  });
}
// 
public getequifaxscore(email) {
  // const sellerId = localStorage.getItem('userEmail');
     const sellerId = email;
 
  const data = {
      "emailId": sellerId
     }
  console.log('data', data);
  const body = JSON.stringify(data);
  console.log(body);
  const head = new Headers({
      'Content-Type': 'application/json'
  });
  return this.http.post(environment.baseUrl + '/cam/get_equifax_score_for_distributor', body,GlobalService.getHeaders()).map((response: Response) => {
    console.log(response)
    console.log(response.status);
    const user = response.json();
    user.responseStatus = response.status;
    console.log(user);
    if (response.status === 200 ) {
      return user;
    }
   }).catch((error) => {
    console.log('error', error);
    if (error.status === 500) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 400) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 401) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    }
  });
}

// get equfax score by channel onboarded
public getChannelEquifaxAnchor(formdata) {
 
  const data = {
      "emailId": formdata.email
     }                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            
  console.log('data', data);
  const body = JSON.stringify(data);
  console.log(body);
  const head = new Headers({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*'
  });
  return this.http.post(environment.baseUrl + '/cam/get_equifax_score_for_distributor', body,{headers: head}).map((response: Response) => {
  // return this.http.post(environment.panUrl + '/score/distributeronboarding', body,{headers: head}).map((response: Response) => {
    console.log(response.status);
    const user = response.json();
    user.responseStatus = response.status;
    console.log(user);
    if (response.status === 200 ) {
      return user;
    }
   }).catch((error) => {
    console.log('error', error);
    if (error.status === 500) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 400) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 401) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    }
  });
}

// get equfax score by channel onboarded
public geteChannelquifaxscore(formdata) {
 
  const data = {
      "userid": formdata.email
     }
  console.log('data', data);
  const body = JSON.stringify(data);
  console.log(body);
  const head = new Headers({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*'
  });
  return this.http.post(environment.panUrl + '/score/distributeronboarding', body,{headers: head}).map((response: Response) => {
  // return this.http.post(environment.panUrl + '/score/distributeronboarding', body,{headers: head}).map((response: Response) => {
    console.log(response.status);
    const user = response.json();
    user.responseStatus = response.status;
    console.log(user);
    if (response.status === 200 ) {
      return user;
    }
   }).catch((error) => {
    console.log('error', error);
    if (error.status === 500) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 400) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 401) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    }
  });
}
//
public getEquifaxscore(email) {
  // const sellerId = localStorage.getItem('userEmail');
  const sellerId = email;
 
  const data = {
      // "address": formdata.address,
      // "addresstype": "OTHERS",
      // "city": formdata.city,
      // "dob": formdata.dateOfBirth,
      // "emailid": formdata.email,
      // "firstname": formdata.userName,
      // "lastname" : "",
      // "gender": formdata.ygender,
      // "idtype": "pan",
      // "idvalue": formdata.pan,
      // "middlename": "",
      // "phoneno": formdata.mobileNumber,
      // "pincode": formdata.pincode,
      // "state": formdata.state,
      // "userid": formdata.email
      "emailId": sellerId
     }
  const body = JSON.stringify(data);

  const head = new Headers({
      'Content-Type': 'application/json'
  });
  return this.http.post(environment.baseUrl + '/cam/get_equifax_score_for_retailer', body , GlobalService.getHeaders()).map((response: Response) => {
    console.log(response.status);
    console.log(response)
    const user = response.json();
    user.responseStatus = response.status;
    console.log(user);
    if (response.status === 200 ) {
      return user;
    }
   }).catch((error) => {

    if (error.status === 500) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 400) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 401) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    }
  });
} 

public KycOnboarding(formdata) {
  const role = localStorage.getItem('role');
  console.log('role', role);
 {
    const data = {
      "coApplicant":[{"PANNumber":formdata.pan, "aadharImageFront":formdata.selfAdhaarUpload, "name":formdata.userName}, {"PANNumber":formdata.pan1, "mobileNumber":formdata.coMobile, "aadharImageFront":formdata.selfAdhaarUpload1, "name":formdata.userName1}],
      "profilePicture":formdata.profilePicUpload,
      // "loanType":formdata.loanType,
      // "loanCategory":formdata.ProductType,
      "productCategory":formdata.ProductType,
      "companyFullName":formdata.companyfullName,
      "companyFullAddress":formdata.address,
      "companyType":formdata.companyType,
      "websiteAddress":formdata.website,
      "emailId":formdata.email,
      "city":formdata.city,
      "state":formdata.state,
      "pinCode":formdata.pincode,
      "country":formdata.country,
      "noOfOffices":formdata.offices,
      "typeOfOffices":formdata.officesType,
      "noOfEMPShowroom":formdata.showroom,
      "typeOfShowroom":formdata.showroomType,
      "noOfWarehouse":formdata.warehouses,
      "noOfEMPWarehouse":formdata.emparehouse,
      "phoneNumber":formdata.phone,
      // "mobileNumber":"+91"+formdata.mobileNumber,
      "mobileNumber": formdata.mobileNumber,
      "DetailAboutCompany":formdata.aboutCompany,
      "GSTNumber":(formdata.gst).toUpperCase(),
      "accountNumber":formdata.accntNum,
      "accountHolderName":formdata.accntName,
      "bankName":formdata.bankName,
      "accountType":formdata.atype,
      "IFSCCode":(formdata.IFSC).toUpperCase(),
      "bankstatement":formdata.bankStatement,
      "PANNumber":(formdata.ComPan).toUpperCase(),
      "accountName":formdata.accntName,
      "roles":[role],
      "limitCash":"",
      "security":formdata.security,
      "isPrimary":true,  
      "retailerAddress":"", 
      "CIN": (formdata.CIN),
      "region": formdata.Region,
      "loanRequestAmount": formdata.loanRequestAmount,
      "manufacturer":[formdata.Product1, formdata.Product2,formdata.Product3],
      "aadharSDK":{"name": formdata.AadharName, "dateOfBirth": formdata.dateOfBirth , "gender": formdata.Gender}
      }
    console.log('Final_data_Submit', data);
    const body = JSON.stringify(data); 
    console.log(body);
    return this.http.post(environment.baseUrl + '/user/kyc', body, GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      if (response.status === 200 ) {
        return user;
      }
     }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      } else if (error.status === 400) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      } else if (error.status === 401) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      }
    });
  }

}
// corporate kuc
public corporateKyc(formdata) {
  const role = localStorage.getItem('role');
  console.log('role', role);
 { 
    const data = {
      "coApplicant":[{"PANNumber":(formdata.pan), "aadharImageFront":formdata.selfAdhaarUpload, "name":formdata.userName}, {"PANNumber":formdata.pan1, "mobileNumber":formdata.coMobile, "aadharImageFront":formdata.selfAdhaarUpload1, "name":formdata.userName1}],
      "profilePicture":formdata.profilePicUpload,
      // "laonType":formdata.loanType,
      // "loanCategory":formdata.ProductType,
      "productCategory":formdata.ProductType,
      "companyFullName":formdata.companyfullName,
      "companyFullAddress":formdata.address,
      "companyType":formdata.companyType,
      "websiteAddress":formdata.website,
      "emailId":formdata.email,
      "city":formdata.city,
      "state":formdata.state,
      "pinCode":formdata.pincode,
      "country":formdata.country,
      "noOfOffices":0,
      "typeOfOffices":"",
      "noOfEMPShowroom":0,
      "typeOfShowroom":"",
      "noOfWarehouse":0,
      "noOfEMPWarehouse":0,
      "phoneNumber":formdata.phone,
      // "mobileNumber":"+91"+formdata.mobileNumber,
      "mobileNumber": formdata.mobileNumber,
      "DetailAboutCompany":formdata.aboutCompany,
      "GSTNumber":(formdata.gst),
      "accountNumber":formdata.accntNum,
      "accountHolderName":formdata.accntName,
      "bankName":formdata.bankName,
      "accountType":formdata.atype,
      "IFSCCode":formdata.IFSC,
      "bankstatement":formdata.bankStatement,
      "PANNumber":(formdata.ComPan).toUpperCase(),
      "accountName":formdata.accntName,
      "roles":[role],
      "limitCash":"",
      "security":formdata.security,
      "isPrimary":true, 
      "retailerAddress":"", 
      "CIN": (formdata.CIN),
      "region": formdata.Region,
      "loanRequestAmount": formdata.loanRequestAmount,
      "manufacturer":[formdata.Product1, formdata.Product2,formdata.Product3],
      "aadharSDK":{"name": formdata.AadharName, "dateOfBirth": formdata.dateOfBirth , "gender": formdata.Gender}
      }
    console.log('Final_data_Submit', data);
    const body = JSON.stringify(data); 
    console.log(body);
    return this.http.post(environment.baseUrl + '/user/kyc', body, GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      if (response.status === 200 ) {
        return user;
      }
     }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      } else if (error.status === 400) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      } else if (error.status === 401) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      }
    });
  }

}
// anchor update kyc
public KycUpdate(formdata) {
  const role = localStorage.getItem('userRole');
  console.log('role', role);
 {
    const data = {
      "coApplicant":[{"PANNumber":(formdata.pan), "aadharImageFront":formdata.selfAdhaarUpload, "name":formdata.userName}, {"PANNumber":formdata.pan1, "aadharImageFront":formdata.selfAdhaarUpload1, "name":formdata.userName1}],
      "profilePicture":formdata.profilePicUpload,
      "productCategory":formdata.ProductType,
      "companyFullName":formdata.companyfullName,
      "companyFullAddress":formdata.address,
      "companyType":formdata.companyType,
      "websiteAddress":formdata.website,
      "emailId":formdata.email,
      "city":formdata.city,
      "state":formdata.state,
      "pinCode":formdata.pincode,
      "country":formdata.country,
      "noOfOffices":formdata.offices,
      "typeOfOffices":formdata.officesType,
      "noOfEMPShowroom":formdata.showroom,
      "typeOfShowroom":formdata.showroomType,
      "noOfWarehouse":formdata.warehouses,
      "noOfEMPWarehouse":formdata.emparehouse,
      "phoneNumber":formdata.phone,
      // "mobileNumber":"+91"+formdata.mobileNumber,
      "mobileNumber":formdata.mobileNumber,
      "DetailAboutCompany":formdata.aboutCompany,
      "GSTNumber":(formdata.gst).toUpperCase(),
      "accountNumber":formdata.accntNum,
      "accountHolderName":formdata.accntName,
      "bankName":formdata.bankName,
      "accountType":formdata.atype,
      "IFSCCode":formdata.IFSC,
      "bankstatement":formdata.bankStatement,
      "PANNumber":(formdata.ComPan).toUpperCase(),
      "accountName":formdata.accntName,
      "roles":[role],
      "limitCash":"",
      "security":formdata.security,
      "isPrimary":true, 
      "retailerAddress":"", 
      "CIN": (formdata.CIN),
      "region": formdata.Region,
      "loanRequestAmount": formdata.loanRequestAmount,
      "manufacturer":[formdata.Product1, formdata.Product2,formdata.Product3],
      "aadharSDK":{"name": formdata.AadharName, "dateOfBirth": formdata.dateOfBirth , "gender": formdata.Gender}
      }
    console.log('Final_data_Submit', data);
    const body = JSON.stringify(data); 
    console.log(body);
    return this.http.put(environment.baseUrl + '/user/update_kyc_profile', body, GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      if (response.status === 200 ) {
        return user;
      }
     }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      } else if (error.status === 400) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      } else if (error.status === 401) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      }
    });
  }

}
// 
// anchor update kyc
public KycUpdateCorporate(formdata) {
  const role = localStorage.getItem('role');
  console.log('role', role);
 {
  const data = {
    "coApplicant":[{"PANNumber":(formdata.pan), "aadharImageFront":formdata.selfAdhaarUpload, "name":formdata.userName}, {"PANNumber":formdata.pan1, "aadharImageFront":formdata.selfAdhaarUpload1, "name":formdata.userName1}],
    "profilePicture":formdata.profilePicUpload,
    "productCategory":formdata.ProductType,
    "companyFullName":formdata.companyfullName,
    "companyFullAddress":formdata.address,
    "companyType":formdata.companyType,
    "websiteAddress":formdata.website,
    "emailId":formdata.email,
    "city":formdata.city,
    "state":formdata.state,
    "pinCode":formdata.pincode,
    "country":formdata.country,
    "noOfOffices":0,
    "typeOfOffices":"",
    "noOfEMPShowroom":0,
    "typeOfShowroom":"",
    "noOfWarehouse":0,
    "noOfEMPWarehouse":0,
    "phoneNumber":formdata.phone,
    // "mobileNumber":"+91"+formdata.mobileNumber,
    "mobileNumber":formdata.mobileNumber,
    "DetailAboutCompany":formdata.aboutCompany,
    "GSTNumber":(formdata.gst).toUpperCase(),
    "accountNumber":formdata.accntNum,
    "accountHolderName":formdata.accntName,
    "bankName":formdata.bankName,
    "accountType":formdata.atype,
    "IFSCCode":formdata.IFSC,
    "bankstatement":formdata.bankStatement,
    "PANNumber":(formdata.ComPan).toUpperCase(),
    "accountName":formdata.accntName,
    "roles":[role],
    "limitCash":"",
    "security":formdata.security,
    "isPrimary":true, 
    "retailerAddress":"", 
    "CIN": (formdata.CIN),
    "region": formdata.Region,
    "loanRequestAmount": formdata.loanRequestAmount,
    "manufacturer":[formdata.Product1, formdata.Product2,formdata.Product3],
    "aadharSDK":{"name": formdata.AadharName, "dateOfBirth": formdata.dateOfBirth , "gender": formdata.Gender}
    }
    console.log('Final_data_Submit', data);
    const body = JSON.stringify(data); 
    console.log(body);
    return this.http.put(environment.baseUrl + '/corporate/corporate_update_kyc', body, GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      if (response.status === 200 ) {
        return user;
      }
     }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      } else if (error.status === 400) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      } else if (error.status === 401) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      }
    });
  }

}
// onboarding customer by channel anchor
public OnboardingAnchorByChannel(formdata) {
  const role = localStorage.getItem('userRole');
  const channelEmailId = localStorage.getItem('channelEmail') || localStorage.getItem('RMEmail')
  console.log('role', role);
 {
    const data = {
      "coApplicant":[{"PANNumber":(formdata.pan), "aadharImageFront":formdata.selfAdhaarUpload, "name":formdata.userName}, {"PANNumber":formdata.pan1, "mobileNumber":formdata.coMobile, "aadharImageFront":formdata.selfAdhaarUpload1, "name":formdata.userName1}],
      "profilePicture":formdata.profilePicUpload,
      "loanType":formdata.loanType,
      "loanCategory":formdata.ProductType,
      "productCategory":formdata.ProductTypec,
      "companyFullName":formdata.companyfullName,
      "companyFullAddress":formdata.address,
      "companyType":formdata.companyType,
      "websiteAddress":formdata.website,
      "emailId":formdata.email,
      "city":formdata.city,
      "state":formdata.state,
      "pinCode":formdata.pincode,
      "country":formdata.country,
      "noOfOffices":formdata.offices,
      "typeOfOffices":formdata.officesType,
      "noOfEMPShowroom":formdata.showroom,
      "typeOfShowroom":formdata.showroomType,
      "noOfWarehouse":formdata.warehouses,
      "noOfEMPWarehouse":formdata.emparehouse,
      "phoneNumber":formdata.phone,
      // "mobileNumber":"+91"+formdata.mobileNumber,
      "mobileNumber":formdata.mobileNumber,
      "DetailAboutCompany":formdata.aboutCompany,
      "GSTNumber":(formdata.gst).toUpperCase(),
      "accountNumber":formdata.accntNum,
      "accountHolderName":formdata.accntName,
      "bankName":formdata.bankName,
      "accountType":formdata.atype,
      "IFSCCode":formdata.IFSC, 
      "bankstatement":formdata.bankstatement,
      "PANNumber":(formdata.ComPan).toUpperCase(),
      "accountName":formdata.accntName,
      "roles":[role],
      "limitCash":"",
      "security":formdata.security,
      "isPrimary":true, 
      "retailerAddress":"", 
      "CIN": (formdata.CIN),
      "region": formdata.Region,
      "createdBy": channelEmailId,
      "loanRequestAmount": formdata.loanRequestAmount,
      "manufacturer":[formdata.Product1, formdata.Product2,formdata.Product3],
      "aadharSDK":{"name": formdata.AadharName, "dateOfBirth": formdata.dateOfBirth , "gender": formdata.Gender}
      }
    console.log('Final_data_Submit', data);
    const body = JSON.stringify(data); 
    console.log(body);
    return this.http.post(environment.baseUrl + '/channelpartner/user_kyc', body, GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      if (response.status === 200 ) {
        return user;
      }
     }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      } else if (error.status === 400) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      } else if (error.status === 401) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      }
    });
  }

}

// onboarding customer by channel anchor
public OnboardingAnchorByRM(formdata) {
  const role = localStorage.getItem('userRole');
  const channelEmailId = localStorage.getItem('channelEmail') || localStorage.getItem('RMEmail')
  console.log('role', role);
 {
    const data = {
      "coApplicant":[{"PANNumber":(formdata.pan), "aadharImageFront":formdata.selfAdhaarUpload, "name":formdata.userName}, {"PANNumber":formdata.pan1, "mobileNumber":formdata.coMobile, "aadharImageFront":formdata.selfAdhaarUpload1, "name":formdata.userName1}],
      "profilePicture":formdata.profilePicUpload,
      "loanType":formdata.loanType,
      "loanCategory":formdata.ProductType,
      "productCategory":formdata.ProductTypec,
      "companyFullName":formdata.companyfullName,
      "companyFullAddress":formdata.address,
      "companyType":formdata.companyType,
      "websiteAddress":formdata.website,
      "emailId":formdata.email,
      "city":formdata.city,
      "state":formdata.state,
      "pinCode":formdata.pincode,
      "country":formdata.country,
      "noOfOffices":formdata.offices,
      "typeOfOffices":formdata.officesType,
      "noOfEMPShowroom":formdata.showroom,
      "typeOfShowroom":formdata.showroomType,
      "noOfWarehouse":formdata.warehouses,
      "noOfEMPWarehouse":formdata.emparehouse,
      "phoneNumber":formdata.phone,
      // "mobileNumber":"+91"+formdata.mobileNumber,
      "mobileNumber":formdata.mobileNumber,
      "DetailAboutCompany":formdata.aboutCompany,
      "GSTNumber":(formdata.gst).toUpperCase(),
      "accountNumber":formdata.accntNum,
      "accountHolderName":formdata.accntName,
      "bankName":formdata.bankName,
      "accountType":formdata.atype,
      "IFSCCode":formdata.IFSC, 
      "bankstatement":formdata.bankstatement,
      "PANNumber":(formdata.ComPan).toUpperCase(),
      "accountName":formdata.accntName,
      "roles":[role],
      "limitCash":"",
      "security":formdata.security,
      "isPrimary":true, 
      "retailerAddress":"", 
      "CIN": (formdata.CIN),
      "region": formdata.Region,
      "createdBy": channelEmailId,
      "loanRequestAmount": formdata.loanRequestAmount,
      "manufacturer":[formdata.Product1, formdata.Product2,formdata.Product3],
      "aadharSDK":{"name": formdata.AadharName, "dateOfBirth": formdata.dateOfBirth , "gender": formdata.Gender}
      }
    console.log('Final_data_Submit', data);
    const body = JSON.stringify(data); 
    console.log(body);
    return this.http.post(environment.baseUrl + '/relationmanager/user_kyc', body, GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      if (response.status === 200 ) {
        return user;
      }
     }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      } else if (error.status === 400) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      } else if (error.status === 401) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      }
    });
  }

}

// kyc channel code start here 

public KycChannel(formdata) {
  const role = localStorage.getItem('role');
  console.log('role', role);
 {
    const data = {
      "emailId":formdata.email,
      "name":formdata.fullName,
      // "mobileNumber":"+91"+formdata.mobileNumber,
      "mobileNumber":formdata.mobileNumber,
      "PANNumber":(formdata.ComPan).toUpperCase(),
      "address":formdata.address, 
      "city":formdata.city,
      "state":formdata.state,
      "pinCode":formdata.pincode,
      "roles":[role],
      "GSTNumber": (formdata.gst).toUpperCase(),
      "companyType": formdata.companyType

      }
    console.log('Final_data_Submit', data);
    const body = JSON.stringify(data); 
    console.log(body);
    return this.http.post(environment.baseUrl + '/channelpartner/kyc', body, GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      if (response.status === 200 ) {
        return user;
      }
     }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      } else if (error.status === 400) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      } else if (error.status === 401) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      }
    });
  }

}
public KycRetailer(formdata) {
  const role = localStorage.getItem('role');
 {
    const data = {
      "coApplicant":[{"PANNumber":(formdata.pan), "aadharImageFront":formdata.selfAdhaarUpload, "name":formdata.userName}, {"PANNumber":(formdata.pan1),"mobileNumber":formdata.coMobile, "aadharImageFront":formdata.selfAdhaarUpload1, "name":formdata.userName1}],
      "profilePicture":formdata.profilePicUpload,
      "productCategory":"",
      "companyFullName":formdata.companyfullName,
      "companyFullAddress":formdata.address,
      "companyType":formdata.companyType,
      "websiteAddress":"",
      "emailId":formdata.email,
      "city":formdata.city,
      "state":formdata.state,
      "pinCode":formdata.pincode,
      "country": formdata.country,
      "noOfOffices": 0,
      "typeOfOffices":"",
      "noOfEMPShowroom":0,
      "typeOfShowroom":"",
      "noOfWarehouse":0,
      "noOfEMPWarehouse":0,
      "phoneNumber":formdata.mobileNumber,
      // "mobileNumber":"+91"+formdata.mobileNumber,
      "mobileNumber":formdata.mobileNumber,
      "DetailAboutCompany":formdata.aboutCompany,
      "GSTNumber":(formdata.gst).toUpperCase(),
      "accountNumber":formdata.accntNum,
      "accountHolderName":formdata.accntName,
      "bankName":formdata.bankName,
      "accountType":formdata.atype,
      "IFSCCode": formdata.IFSC,
      "bankstatement":formdata.bankStatement,
      "PANNumber":(formdata.ComPan).toUpperCase(),
      "accountName":formdata.accntName,
      "roles":[role],
      "limitCash":"",
      "security":"", 
      "isPrimary":true,
      "retailerAddress":formdata.address, 
      "CIN": formdata.cinNumber ? formdata.cinNumber : "",
      "distributorCompanyName": formdata.distributorCompanyName,
      "region": formdata.Region,
      'distributorId':[formdata.distributorSelected],
      "loanRequestAmount": formdata.loanRequestAmount,
      "manufacturer":[formdata.Product1, formdata.Product2,formdata.Product3],
      "aadharSDK":{"name": formdata.AadharName, "dateOfBirth": formdata.dateOfBirth , "gender": formdata.Gender}
      }
    const body = JSON.stringify(data); 

    return this.http.post(environment.baseUrl + '/user/kyc', body, GlobalService.getHeaders()).map((response: Response) => {

      const user = response.json();
      user.responseStatus = response.status;

      if (response.status === 200 ) {
        return user;
      }
     }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      } else if (error.status === 400) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      } else if (error.status === 401) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      }
    });
  }

}
// retailer update
public retailerUpdate(formdata) {
  const role = localStorage.getItem('role');
  console.log('role', role);
 {
    const data = {
      "coApplicant":[{"PANNumber":(formdata.pan), "aadharImageFront":formdata.selfAdhaarUpload, "name":formdata.userName}, {"PANNumber":(formdata.pan1), "aadharImageFront":formdata.selfAdhaarUpload1, "name":formdata.userName1}],
      "profilePicture":formdata.profilePicUpload,
      "productCategory":"",
      "companyFullName":formdata.companyfullName,
      "companyFullAddress":formdata.address,
      "companyType":formdata.companyType,
      "websiteAddress":"",
      "emailId":formdata.email,
      "city":formdata.city,
      "state":formdata.state,
      "pinCode":formdata.pincode,
      "country":formdata.country,
      "noOfOffices": 0,
      "typeOfOffices":"",
      "noOfEMPShowroom":0,
      "typeOfShowroom":"",
      "noOfWarehouse":0,
      "noOfEMPWarehouse":0,
      "phoneNumber":formdata.mobileNumber,
      // "mobileNumber":"+91"+formdata.mobileNumber,
      "mobileNumber":formdata.mobileNumber,
      "DetailAboutCompany":formdata.aboutCompany,
      "GSTNumber":(formdata.gst).toUpperCase(),
      "accountNumber":formdata.accntNum,
      "accountHolderName":formdata.accntName,
      "bankName":formdata.bankName,
      "accountType":formdata.atype,
      "IFSCCode": formdata.IFSC,
      "bankstatement":formdata.bankStatement,
      "PANNumber":formdata.ComPan,
      "accountName":formdata.accntName,
      "roles":[role],
      "limitCash":"",
      "security":"", 
      "isPrimary":true,
      "retailerAddress":formdata.address, 
      "CIN": formdata.CIN ? formdata.CIN : "",
      "region": formdata.Region,
      // 'distributorId':[formdata.distributorSelected],
      "loanRequestAmount": formdata.loanRequestAmount,
      "manufacturer":[formdata.Product1, formdata.Product2,formdata.Product3],
      "aadharSDK":{"name": formdata.AadharName, "dateOfBirth": formdata.dateOfBirth , "gender": formdata.Gender}
      }
    console.log('Final_data_Submit', data);
    const body = JSON.stringify(data); 
    console.log(body);
    return this.http.put(environment.baseUrl + '/user/update_kyc_profile', body, GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      if (response.status === 200 ) {
        return user;
      }
     }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      } else if (error.status === 400) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      } else if (error.status === 401) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      }
    });
  }

}
// kyc onboard by channer retailer
public KycRetailerChannel(formdata) {
  const role = localStorage.getItem('userRole');
  const channelEmailId = localStorage.getItem('channelEmail') || localStorage.getItem('RMEmail')
  console.log('role', role);
 {
    const data = {
      "coApplicant":[{"PANNumber":(formdata.pan), "aadharImageFront":formdata.selfAdhaarUpload, "name":formdata.userName}, {"PANNumber":(formdata.pan1), "mobileNumber":formdata.coMobile, "aadharImageFront":formdata.selfAdhaarUpload1, "name":formdata.userName1}],
      "profilePicture":formdata.profilePicUpload,
      "productCategory":"",
      "companyFullName":formdata.companyfullName,
      "companyFullAddress":formdata.address,
      "companyType":formdata.companyType,
      "websiteAddress":"",
      "emailId":formdata.email,
      "city":formdata.city,
      "state":formdata.state,
      "pinCode":formdata.pincode,
      "country":formdata.country,
      "noOfOffices": 0,
      "typeOfOffices":"",
      "noOfEMPShowroom":0,
      "typeOfShowroom":"",
      "noOfWarehouse":0,
      "noOfEMPWarehouse":0,
      "phoneNumber":formdata.mobileNumber,
      // "mobileNumber":"+91"+formdata.mobileNumber,
      "mobileNumber": formdata.mobileNumber,
      "DetailAboutCompany":formdata.aboutCompany,
      "GSTNumber":(formdata.gst).toUpperCase(),
      "accountNumber":formdata.accntNum,
      "accountHolderName":formdata.accntName,
      "bankName":formdata.bankName,
      "accountType":formdata.atype,
      "IFSCCode": formdata.IFSC,
      "bankstatement":formdata.bankstatement,
      "PANNumber":(formdata.ComPan).toUpperCase(),
      "accountName":formdata.accntName,
      "roles":[role],
      "limitCash":"",
      "security":"", 
      "isPrimary":true,
      "retailerAddress":formdata.address, 
      "CIN": "",
      "region": formdata.Region,
      "createdBy": channelEmailId,
      "distributorCompanyName": formdata.distributorCompanyName,
      'distributorId':[formdata.distributorSelected],
      "loanRequestAmount": formdata.loanRequestAmount,
      "manufacturer":[formdata.Product1, formdata.Product2,formdata.Product3],
      "aadharSDK":{"name": formdata.AadharName, "dateOfBirth": formdata.dateOfBirth , "gender": formdata.Gender}
      }
    console.log('Final_data_Submit', data);
    const body = JSON.stringify(data); 
    console.log(body);
    return this.http.post(environment.baseUrl + '/channelpartner/user_kyc', body, GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      if (response.status === 200 ) {
        return user;
      }
     }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      } else if (error.status === 400) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      } else if (error.status === 401) {

        const err = error.json();
        err.responseStatus = error.status;
        
        return Observable.throw(err);
      }
    });
  }

}
//verify  personal PAN verification
public verifyPersonalPan(personalPan) {
 
  return this.http.get(environment.baseUrl + '/user/verify_personal_pan/' + personalPan ,
  GlobalService.getHeaders()).map((response: Response) => {
    console.log(response.status);
    const user = response.json();
    user.responseStatus = response.status;
    console.log(user);
    return user;
  }).catch((error) => {
    console.log('error', error);
    if (error.status === 500) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 400) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 401) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    }
});
}
// 
//verify  company PAN verification
public verifyCompanyPan(companyPan) {

  return this.http.get(environment.baseUrl + '/user/verify_company_pan/' + companyPan ,
  GlobalService.getHeaders()).map((response: Response) => {
    console.log(response.status);
    const user = response.json();
    user.responseStatus = response.status;
    console.log(user);
    return user;
  }).catch((error) => {
    console.log('error', error);
    if (error.status === 500) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 400) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 401) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    }
});
}
// 
//verify  GST verification
public verifyGst(gstNumber) {
  
  return this.http.get(environment.baseUrl + '/user/verify_gst/' + gstNumber ,
  GlobalService.getHeaders()).map((response: Response) => {
    console.log(response.status);
    const user = response.json();
    user.responseStatus = response.status;
    console.log(user);
    return user;
  }).catch((error) => {
    console.log('error', error);
    if (error.status === 500) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 400) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 401) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    }
});
}
//verify  aadhar verification
public verifyAadhar(aadharNumber) {
  console.log('inside services');
  return this.http.get(environment.baseUrl + '/user/verify_aadhar/' + aadharNumber ,
  GlobalService.getHeaders()).map((response: Response) => {
    console.log(response.status);
    const user = response.json();
    user.responseStatus = response.status;
    console.log(user);
    return user;
  }).catch((error) => {
    console.log('error', error);
    if (error.status === 500) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 400) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 401) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    }
});
}
// logout functionpublic verifyCompanyPan(companyPan) {
  public logOut() {
    console.log('inside services');
    const emailId = localStorage.getItem('userEmail');
 
    const data = {
        "emailId": emailId,
      
       }
    console.log('data', data);
    const body = JSON.stringify(data);
    console.log(body);
    
    
  return this.http.post(environment.baseUrl + '/user/sign-out' ,
  body , GlobalService.getHeaders()).map((response: Response) => {
    console.log(response.status);
    const user = response.json();
    user.responseStatus = response.status;
    console.log(user);
    return user;
  }).catch((error) => {
    console.log('error', error);
    if (error.status === 500) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 400) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 401) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    }
});
}
// 
// delete
public deleteDocument(docUrl,key) {
  console.log('update Item', docUrl);
  const emailId = localStorage.getItem('userEmail')
  const data = {
    "email_id": emailId,
    "image_url": docUrl,
    "key":key
};
  console.log('data', data);
  const body = JSON.stringify(data);
  console.log(body);
  return this.http.put(environment.docDel+'/kyc/delete_file',
  body,GlobalService.getHeaders()).map((response: Response) => {
    console.log(response.status);
    const user = response.json();
    user.responseStatus = response.status;
    console.log(user);
    return user;
  }).catch((error) => {
    console.log('error', error);
    if (error.status === 500) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 400) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 401) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    }
});
}
// delete channel docs
// delete
public deleteChannelDocument(docUrl,key,emailId) {
  console.log('update Item', docUrl);
  const data = {
    "email_id": emailId,
    "image_url": docUrl,
    "key":key
};
  console.log('data', data);
  const body = JSON.stringify(data);
  console.log(body);
  return this.http.put(environment.docDel+'/kyc/delete_file',
  body,GlobalService.getHeaders()).map((response: Response) => {
    console.log(response.status);
    const user = response.json();
    user.responseStatus = response.status;
    console.log(user);
    return user;
  }).catch((error) => {
    console.log('error', error);
    if (error.status === 500) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 400) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 401) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    }
});
}
// for upload docAP
public apUpload(Image) {
  console.log('image', Image);
  const sellerId = localStorage.getItem('userEmail');
  const roles = localStorage.getItem('role');
  const formData: FormData = new FormData();
  formData.append('addressProof', Image);
  formData.append('emailId', sellerId);
  formData.append('roles', roles);
  return this.http.post(environment.docUrl + '/kyc/docs', formData).map((response: Response) => {
    console.log(response.status);
    const user = response.json();
    user.responseStatus = response.status;
    if (response.status === 200 ) {
      return user;
    }
   }).catch((error) => {
    console.log('error', error);
    if (error.status === 500) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 400) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 401) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    }
  });
}
// for upload docBr
public brUpload(Image) {
  console.log('image', Image);
  const sellerId = localStorage.getItem('userEmail');
  const roles = localStorage.getItem('role');
  const formData: FormData = new FormData();
  formData.append('buerauReport', Image);
  formData.append('emailId', sellerId);
  formData.append('roles', roles);
  return this.http.post(environment.docUrl + '/kyc/docs', formData).map((response: Response) => {
    console.log(response.status);
    const user = response.json();
    user.responseStatus = response.status;
    if (response.status === 200 ) {
      return user;
    }
   }).catch((error) => {
    console.log('error', error);
    if (error.status === 500) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 400) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 401) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    }
  });
}
// for upload doc BP
public bpUpload(Image) {
  console.log('image', Image);
  const sellerId = localStorage.getItem('userEmail');
  const roles = localStorage.getItem('role');
  const formData: FormData = new FormData();
  formData.append('businessProfile', Image);
  formData.append('emailId', sellerId);
  formData.append('roles', roles);
  return this.http.post(environment.docUrl + '/kyc/docs', formData).map((response: Response) => {
    console.log(response.status);
    const user = response.json();
    user.responseStatus = response.status;
    if (response.status === 200 ) {
      return user;
    }
   }).catch((error) => {
    console.log('error', error);
    if (error.status === 500) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 400) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 401) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    }
  });
}

//
public panValidation(formdata) {
 
  const data = {
    "pinCode": formdata.pinCode,
    "city":formdata.city
  };
  console.log('data', data);
  const body = JSON.stringify(data);
  console.log(body);
  return this.http.post(environment.baseUrl + '/validation/pincode', body,GlobalService.getHeaders()).map((response: Response) => {
    console.log(response.status);
    const user = response.json();
    user.responseStatus = response.status;
    console.log(user);
    if (response.status === 200 ) {
      return user;
    }
   }).catch((error) => {
    console.log('error', error);
    if (error.status === 500) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 400) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 401) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    }
  });
} 
public ifscValidation(formdata) {
  const sellerId = localStorage.getItem('userEmail');
 
  const data = {
    "IFSC_Code":formdata.IFSC_Code,
    "Bank_Name":formdata.Bank_Name
  };
  console.log('data', data);
  const body = JSON.stringify(data);
  console.log(body);
  return this.http.post(environment.baseUrl + '/validation/ifsc', body,GlobalService.getHeaders()).map((response: Response) => {
    console.log(response.status);
    const user = response.json();
    user.responseStatus = response.status;
    console.log(user);
    if (response.status === 200 ) {
      return user;
    }
   }).catch((error) => {
    console.log('error', error);
    if (error.status === 500) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 400) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    } else if (error.status === 401) {
      const err = error.json();
      err.responseStatus = error.status;
      
      return Observable.throw(err);
    }
  });
}  

public OnboardingRMByAdmin(formdata) {
  const role = localStorage.getItem('userRole');
  // const channelEmailId = localStorage.getItem('channelEmail')
  console.log('role', role);
  console.log("In onboardingRM by Admin")
  {
      const data = {
        "emailId":formdata.email,
        "name":formdata.fullName,
        // "mobileNumber":"+91"+formdata.mobileNumber,
        "mobileNumber":formdata.mobileNumber,
        "PANNumber":formdata.ComPan,
        "address":formdata.address, 
        "city":formdata.city,
        "state":formdata.state,
        "pinCode":formdata.pincode,
        "roles":[role],
        "GSTNumber": formdata.gst,
        "companyType": formdata.companyType
  
        }
      console.log('Final_data_Submit', data);
      const body = JSON.stringify(data); 
      console.log(body);
      return this.http.post(environment.baseUrl + '/admin-onboarding-rm/kyc', body, GlobalService.getHeaders()).map((response: Response) => {
        // return this.http.post('http://localhost:4200/proxy/admin-onboarding-rm/kyc', body, GlobalService.getHeaders()).map((response: Response) => {

        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        if (response.status === 200 ) {
          return user;
        }
       }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
  
          const err = error.json();
          err.responseStatus = error.status;
          
          return Observable.throw(err);
        } else if (error.status === 400) {
  
          const err = error.json();
          err.responseStatus = error.status;
          
          return Observable.throw(err);
        } else if (error.status === 401) {
  
          const err = error.json();
          err.responseStatus = error.status;
          
          return Observable.throw(err);
        }
      });
    }
  
  }
}